/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = { appearances: {}, rules: [], tokens: { color: '#f9f2dd' } }
export default theme
